module.exports = __webpack_public_path__ + "img/ring-box.aee13616.png";